import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MainWrapper from "../layouts/MainWrapper";
import CardWrapper from "../layouts/CardWrapper";
import DataTable from "../components/Table/Table";
import Image from "react-bootstrap/Image";
import PageTitle from "../components/PageTitle";
import StatusBadge from "../components/StatusBadge/StatusBadge";
import UsersDetailsPanel from "../components/DetailsPanel/UsersDetailsPanel";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import TablePagination from "../components/TablePagination/TablePagination";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import { deleteUser, usersList } from "../services/userService";
import { licenses } from "../services/licenseService";
import ImagePreviewLightbox from "../components/ImagePreviewLightbox";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { authAtom } from "../states/auth";
import { useAtom } from "jotai";
import { singleUser } from "../services/userService";
import useDebounce from "../utils/useDebounce";
import { useAlert } from "../contexts/AlertContext";
import { Modal } from "react-bootstrap";

const roles = {
  3: { label: "Expert", color: "Success" },
  2: { label: "Admin", color: "Completed" },
  5: { label: "Staff", color: "Pending" },
  7: { label: "Internal", color: "Pending" },
};

const getPhone = (userInfo) => {
  let phoneNo = userInfo?.phoneNo || "";
  const countryCode = userInfo?.countryCode || "";
  console.log("asdasd-------------------", phoneNo, countryCode);
  if (phoneNo.startsWith("0")) {
    phoneNo = phoneNo.slice(1);
  }

  const phoneString = `+${countryCode}${phoneNo}`;
  const parsed = parsePhoneNumberFromString(phoneString);

  if (!parsed) return "";

  // 📞 Example output: +91 91234 56789 or +1 (201) 555-0123
  return `+${parsed.countryCallingCode} ${
    parsed.formatNational().startsWith("0")
      ? parsed.formatNational().slice(1)
      : parsed.formatNational()
  }`;
};

const Users = () => {
  const [auth] = useAtom(authAtom);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [licences, setLicences] = useState(null);
  const [selectedPage, setSelectedPage] = useState(1);
  const [filter, setFilter] = useState({
    no_of_result: 10,
    page: 1,
    search: "",
    userTypeFilter: 0,
    sorting: ["firstName:asc"],
  });
 
  const [usersListData, setUsersListData] = useState(null);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [searchFlag, setSearchFlag] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const debouncedSearchTerm = useDebounce(filter, searchFlag ? 500 : 0);

  const { showAlert } = useAlert();

  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      const tempUserData = response?.data?.user;
      if (response?.data?.user) {
        setCompanyDetails(tempUserData);
      }
    });
  }, []);

  const rowHandler = (row) => {
    setSelectedItem(row);
    document.body.classList.add("sidebar-collapsed");
  };

  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      filter.page = 1;
      setSelectedPage(1);
      setSearchFlag(true);
    }
    console.log(e.target.name, e.target.value);
    filter[e.target.name] = e.target.value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  const columns = [
    { label: "Name", key: "firstName" },
    {
      label: "User Role",
      key: "roleId",
    },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phoneNo" },
  ];

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const licencesData = await licenses();
        console.log("licences22", licencesData?.data);
        setLicences(licencesData?.data);
      } catch (error) {
        console.error("Error fetching Licences:", error);
      }
    };

    fetchLicense();
  }, [usersListData]);

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const fetchUsers = async () => {
    try {
      const data = await usersList(filter);
      setUsersListData(data?.data);
      setTotalResults(data?.totalResult);
      console.log("Users", data?.data);
      setSelectedItem(null);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (location.state?.selectUserId && usersListData) {
      const userToSelect = usersListData.find(
        (u) => u.id === location.state.selectUserId,
      );
      if (userToSelect) {
        setSelectedItem(userToSelect);
        document.body.classList.add("sidebar-collapsed");
        window.history.replaceState({}, document.title);
      }
    }
  }, [usersListData, location.state]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      console.log("Performing search for:", debouncedSearchTerm);
      // In a real application, you would make an API call here
      fetchUsers();
      setSearchFlag(false);
    } else {
      console.log("Search term cleared.");
    }
  }, [debouncedSearchTerm]);

  let navigate = useNavigate();
  const editUser = (userId) => {
    navigate("/user/edit/" + userId);
  };

  const deleteUserFunction = async (id) => {
    try {
      const deleteUserData = await deleteUser(id);
      showAlert({
        title: "Users Notification",
        message: deleteUserData?.message ?? "something went wrong",
        variant: "success",
      });
      console.log("delete message", deleteUserData);
      fetchUsers();
      setShowModal(null);
      // setSelectedItem(null);
    } catch (error) {
      console.error("Error saving user:", error);
      setShowModal(null);
      // setSelectedItem(null);
      showAlert({
        title: "Routing Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };
  const BeadcrumbItems = [{ label: "My Team", active: true }];
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7" sm="6">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="My Team" />
        </Col>
        <Col lg="5" sm="6" className="text-end">
          <Link
            to="/users/add"
            className="btn btn-md btn-primary d-inline-flex align-items-center justify-content-end gap-1"
          >
            <Image
              src="/images/plus-white.svg"
              width={20}
              height={20}
              alt="Plus White Icon"
            />
            Add Team Member
          </Link>
        </Col>
      </Row>
      <MainWrapper>
        <CardWrapper>
          <Row className="align-items-center gy-4 gy-xxl-0 mb-4">
            <Col xxl="9" xl="7">
              <div className="d-flex align-items-center gap-4">
                <h2 className="fs-5 fw-semibold text-gray-800 mb-0">
                  All Team Members
                </h2>
                {licences != null && (
                  <ul className="d-flex flex-wrap align-items-center gap-2 list-unstyle ps-0 mb-0">
                    <li className="badge">
                      Expert License:{" "}
                      {(licences?.totalExpertLicence ?? 0) -
                        (licences?.noOfExpertLicence ?? 0)}
                      /{licences?.totalExpertLicence}
                    </li>
                    <li className="badge">
                      Staff License:{" "}
                      {(licences?.totalUserLicence ?? 0) -
                        (licences?.noOfUserLicence ?? 0)}
                      /{licences?.totalUserLicence}
                    </li>
                  </ul>
                )}
              </div>
            </Col>
            <Col xxl="3" xl="5" className="text-end">
              <input
                onChange={changeFilterCriteria}
                name="search"
                type="text"
                className="form-control form-control-search"
                aria-label="Search Input"
                placeholder="Search here.."
                autoComplete="off"
              />
            </Col>
          </Row>
          <DataTable>
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} className="cursor-pointer">
                    <div className="d-flex align-items-center gap-1">
                      {col.label}
                      <span className="d-flex flex-column align-items-center">
                        {col.label === "User Role" && (
                          <Dropdown
                            show={showStatusDropdown}
                            onToggle={(isOpen) => setShowStatusDropdown(isOpen)}
                          >
                            <Dropdown.Toggle
                              variant="light"
                              className="btn-reset dropdown-toggle-none"
                              align="end"
                            >
                              <Image
                                src="/images/funnel.svg"
                                width={20}
                                height={20}
                                alt="Funnel Icon"
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              className="filter-dropdown-menu dropdown-menu-end p-0"
                              align="end"
                              popperConfig={{
                                modifiers: [
                                  {
                                    name: "offset",
                                    options: { offset: [0, 25] },
                                  },
                                ],
                              }}
                            >
                              <div className="px-3 pt-3 pb-2 border-bottom">
                                {/* <Form.Check
                                className="checkbox-primary mb-2"
                                type="radio"
                                name="userTypeFilter"
                                label="All"
                                id="checkbox-all"
                              /> */}
                                <Form.Check
                                  className="checkbox-primary mb-2"
                                  type="radio"
                                  name="userTypeFilter"
                                  value="1"
                                  onChange={changeFilterCriteria}
                                  checked={filter.userTypeFilter === "1"}
                                  label="Expert"
                                  id="checkbox-expert"
                                />
                                <Form.Check
                                  className="checkbox-primary mb-2"
                                  type="radio"
                                  name="userTypeFilter"
                                  value="2"
                                  onChange={changeFilterCriteria}
                                  checked={filter.userTypeFilter === "2"}
                                  label="Staff"
                                  id="checkbox-user"
                                />
                              </div>
                              <div className="p-2 d-flex align-items-center justify-content-between">
                                <button
                                  name="userTypeFilter"
                                  value={0}
                                  onClick={(e) => {
                                    setShowStatusDropdown(false);
                                    changeFilterCriteria(e);
                                  }}
                                  className="btn btn-xm btn-reset text-blue"
                                >
                                  Reset
                                </button>
                                <button className="btn btn-xm btn-blue">
                                  Okay
                                </button>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </span>
                    </div>
                  </th>
                ))}
                <th width="8%">Actions</th>
              </tr>
            </thead>
            <tbody>
              {usersListData?.length > 0 ? (
                usersListData?.map((row, rowIndex) => (
                  <tr key={rowIndex} onClick={() => rowHandler(row)}>
                    <td
                      className={selectedItem?.id === row?.id && "bg-gray-50"}
                    >
                      <div className="d-flex align-items-center gap-2">
                        {row?.profilePic ? (
                          <ImagePreviewLightbox
                            className="table-user-avtar"
                            src={row?.profilePic}
                          >
                            <Image
                              src={row?.profilePic}
                              className="object-fit-cover rounded-circle"
                              width="32"
                              height="32"
                              alt={row?.firstName}
                            />
                          </ImagePreviewLightbox>
                        ) : (
                          <Image
                            width={32}
                            height={32}
                            alt="User Avatar"
                            className="object-fit-cover rounded-circle"
                            src={`https://ui-avatars.com/api/?name=${row?.firstName}+${row?.lastName}&background=007bff&color=fff&size=100`}
                          />
                        )}
                        <span>{row?.firstName + " " + row?.lastName}</span>
                      </div>
                    </td>
                    <td
                      className={selectedItem?.id === row?.id && "bg-gray-50"}
                    >
                      <StatusBadge
                        status={roles[row.roleId]?.color}
                        label={roles[row.roleId]?.label}
                      />
                    </td>
                    <td
                      className={selectedItem?.id === row?.id && "bg-gray-50"}
                    >
                      {row.email}
                    </td>
                    {console.log("this ")}
                    <td
                      className={selectedItem?.id === row?.id && "bg-gray-50"}
                    >
                      {getPhone(row)}
                    </td>
                    <td
                      className={selectedItem?.id === row?.id && "bg-gray-50"}
                    >
                      <div className="column-action-btn d-flex align-items-center gap-3">
                        <button
                          className="btn btn-icon"
                          aria-label="edit-btn"
                          onClick={() => editUser(row?.id)}
                          variant="primary"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.9797 5.5108L14.4891 2.01939C14.344 1.87423 14.1717 1.75908 13.9821 1.68052C13.7925 1.60196 13.5892 1.56152 13.384 1.56152C13.1787 1.56152 12.9755 1.60196 12.7859 1.68052C12.5963 1.75908 12.424 1.87423 12.2789 2.01939L2.64532 11.6538C2.4997 11.7984 2.38424 11.9706 2.30565 12.1602C2.22707 12.3498 2.18691 12.5532 2.18751 12.7585V16.2499C2.18751 16.6643 2.35213 17.0617 2.64515 17.3547C2.93818 17.6477 3.33561 17.8124 3.75001 17.8124H7.24141C7.44668 17.8129 7.65001 17.7727 7.83963 17.6942C8.02926 17.6156 8.2014 17.5001 8.3461 17.3545L17.9797 7.72017C18.2726 7.42716 18.4372 7.02981 18.4372 6.61549C18.4372 6.20117 18.2726 5.80381 17.9797 5.5108ZM7.10938 15.9374H4.06251V12.8905L10.625 6.32799L13.6719 9.37486L7.10938 15.9374ZM15 8.04674L11.9531 4.99986L13.3859 3.56705L16.4328 6.61392L15 8.04674Z"
                              fill="#334155"
                            />
                          </svg>
                        </button>
                        <button
                          className="btn btn-icon"
                          aria-label="Delete Item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowModal(row?.id);
                          }}
                        >
                          <Image
                            src="/images/trash.svg"
                            width={20}
                            height={20}
                            alt="Trash Red Icon"
                          />{" "}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="default-pointer">
                  <td
                    colSpan={columns.length + 1}
                    className="fw-semibold text-center"
                  >
                    {usersListData == null ? "Loading..." : "No Data Available"}
                  </td>
                </tr>
              )}
            </tbody>
          </DataTable>
          <TablePagination
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
            totalResults={totalResults}
            resultsPerPage={10}
          />
        </CardWrapper>

        <UsersDetailsPanel
          item={selectedItem}
          fetchUsers={() => fetchUsers()}
          isOpen={!!selectedItem}
          onClose={() => setSelectedItem(null)}
        />

        <Modal
          className="info-modal"
          show={!!showModal}
          onHide={() => setShowModal(null)}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div className="text-center">
              <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
              <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
                Are you sure you want to delete this user?
              </h2>

              <div className="d-flex align-items-center gap-3">
                <Button
                  variant="primary"
                  onClick={(e) => deleteUserFunction(showModal)}
                  className="btn w-100 mt-5"
                >
                  Delete User
                </Button>
                <Button
                  variant="gray"
                  className="btn w-100 mt-5"
                  onClick={() => setShowModal(null)}
                >
                  Nope, Cancel
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </MainWrapper>
    </>
  );
};

export default Users;
